import { useContext } from 'react';
import { SSEContext } from '../contexts/SSEContext';

export const useSSE = () => useContext(SSEContext);
